import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { DatePicker, Input } from "antd";
import { CalendarIcon } from "Shared/icons";
import dayjs from "dayjs";
import CountrySelect from "Entities/country_select";

import { WithdrawModalsContext } from "../context/WithdrawModalContext";
import { selectUser } from "Features/user";

export const UpdateIbanAccount = () => {
	const { onChangeWalletData, newWalletData, errors } = useContext(WithdrawModalsContext);
	const user = useSelector(selectUser.data);

	const onChangeFirstName = (e) => onChangeWalletData("first_name", e.target.value);
	const onChangeLastName = (e) => onChangeWalletData("last_name", e.target.value);
	const onChangeBirthday = (value) => onChangeWalletData("birthdate", new Date(value).toISOString());
	const onChangeState = (e) => onChangeWalletData("province", e.target.value);
	const onChangeAddress = (e) => onChangeWalletData("address", e.target.value);
	const onChangeCountry = (value) => onChangeWalletData("country_id", value);
	const onChangePostcode = (e) => onChangeWalletData("postcode", e.target.value);
	const onChangePersonalID = (e) => onChangeWalletData("personal_id", e.target.value);

	const [isLatvia, setIsLatvia] = useState(false);

	useEffect(() => {
		if (!newWalletData?.country_id) {
			onChangeCountry(user.country.id);
		}
		// 428 - Latvia country_id
		let tmpIsLatvia = isLatvia;
		const country_id = newWalletData?.country_id || user.country.id;
		if (country_id === 428 && !isLatvia) {
			setIsLatvia(true);
			tmpIsLatvia = true;
		} else if (country_id !== 428 && isLatvia) {
			setIsLatvia(false);
			tmpIsLatvia = false;
		}

		ClearUnusedData(tmpIsLatvia);
	}, [newWalletData]);

	function ClearUnusedData(isLatvia) {
		if (isLatvia) {
			if (newWalletData?.province) onChangeWalletData("province", null);
			if (newWalletData?.postcode) onChangeWalletData("postcode", null);
			if (newWalletData?.address) onChangeWalletData("address", null);
		}
		if (!isLatvia) {
			if (newWalletData?.personal_id) onChangeWalletData("personal_id", null);
		}
	}

	return (
		<>
			<div className="withdraw-modal__row">
				<div className="withdraw-modal__row-label withdraw-modal__row-label_center">
					Please, enter your account data.
				</div>
			</div>
			<div className="withdraw-modal__row">
				<div className="withdraw-modal__row-label">First Name</div>
				<Input
					onChange={onChangeFirstName}
					value={newWalletData?.first_name}
					status={errors?.first_name ? "error" : ""}
				/>
				{errors?.first_name && (
					<div className="error-messages">
						<div className="error-messages__message">{"Please enter a First Name"}</div>
					</div>
				)}
			</div>
			<div className="withdraw-modal__row">
				<div className="withdraw-modal__row-label">Surname</div>
				<Input onChange={onChangeLastName} value={newWalletData?.last_name} status={errors?.last_name ? "error" : ""} />
				{errors?.last_name && (
					<div className="error-messages">
						<div className="error-messages__message">{"Please enter a Surname"}</div>
					</div>
				)}
			</div>
			<div className="withdraw-modal__row withdraw-modal__row_multi">
				<div className="withdraw-modal__row-item">
					<div className="withdraw-modal__row-label">Date of Birth</div>
					<DatePicker
						className="withdraw-modal__datepicker"
						value={newWalletData?.birthdate ? dayjs(newWalletData?.birthdate) : ""}
						clearIcon={false}
						onChange={onChangeBirthday}
						format={"DD.MM.YYYY"}
						showNow={false}
						showToday={false}
						suffixIcon={<CalendarIcon />}
						placeholder={"Date of Birth"}
						status={errors?.birthdate ? "error" : ""}
					/>
					{errors?.birthdate && (
						<div className="error-messages">
							<div className="error-messages__message">{"Please enter a Date of Birth"}</div>
						</div>
					)}
				</div>
				<div className="withdraw-modal__row-item">
					<div className="withdraw-modal__row-label">Country/Region</div>
					<CountrySelect
						value={newWalletData?.country_id || user.country.id}
						onChange={onChangeCountry}
						status={errors?.country_id ? "error" : ""}
					/>
					{errors?.country_id && (
						<div className="error-messages">
							<div className="error-messages__message">{"Please select a Country/Region"}</div>
						</div>
					)}
				</div>
			</div>
			{isLatvia ? (
				<div className="withdraw-modal__row">
					<div className="withdraw-modal__row-label">Personal ID</div>
					<Input
						onChange={onChangePersonalID}
						value={newWalletData?.personal_id}
						status={errors?.personal_id ? "error" : ""}
					/>
					{errors?.personal_id && (
						<div className="error-messages">
							<div className="error-messages__message">{"Please enter a valid Personal ID"}</div>
						</div>
					)}
				</div>
			) : (
				<>
					<div className="withdraw-modal__row withdraw-modal__row_multi">
						<div className="withdraw-modal__row-item">
							<div className="withdraw-modal__row-label">State/Province</div>
							<Input
								onChange={onChangeState}
								value={newWalletData?.province}
								status={errors?.province ? "error" : ""}
							/>
							{errors?.province && (
								<div className="error-messages">
									<div className="error-messages__message">{"Please enter a State/Province"}</div>
								</div>
							)}
						</div>
						<div className="withdraw-modal__row-item">
							<div className="withdraw-modal__row-label">Postcode</div>
							<Input
								onChange={onChangePostcode}
								value={newWalletData?.postcode}
								status={errors?.postcode ? "error" : ""}
							/>
							{errors?.postcode && (
								<div className="error-messages">
									<div className="error-messages__message">{"Please enter a Postcode"}</div>
								</div>
							)}
						</div>
					</div>
					<div className="withdraw-modal__row">
						<div className="withdraw-modal__row-label">Address</div>
						<Input onChange={onChangeAddress} value={newWalletData?.address} status={errors?.address ? "error" : ""} />
						{errors?.address && (
							<div className="error-messages">
								<div className="error-messages__message">{"Please enter a Address"}</div>
							</div>
						)}
					</div>
				</>
			)}
		</>
	);
};
